export default {
  MY_DRAFTS ({ drafts }) {
    return drafts
  }
}
